__turbopack_context__.v({
  "equalize": "voicePicker-module__-UT1-G__equalize",
  "equalizer": "voicePicker-module__-UT1-G__equalizer",
});
